import React from "react"

type Props = {
    menuParams: {
        options             : string[]
        onClickOption       : {(value:string|null):void}
        aggregateFunction   : string
    }
    hidePopover: callback
}

export default function AggregateMoreMenu(props:Props) {

    const onClickOption = (value:string|null) => {
        props.hidePopover();
        props.menuParams.onClickOption(value);
    };

    const maxOptionWidth = _.chain(props.menuParams.options)
        .map(option=> gd.utils.getTextWidth(gd.const.aggregate.name[option]) + 50)
        .max()
        .value();

    const styles = {width: maxOptionWidth > 160 ? '200px' : '160px'};

    return (
        <div className="ui5-popover-menu" style={styles}>
            <div className="ui5-header s11 no-accent">
                <div className="left">
                    <div className="name">Function</div>
                </div>
            </div>

            {_.map(props.menuParams.options, (option,key)=>{
                const classes = Classes('option', /*'with-icon',*/ {
                    selected: props.menuParams.aggregateFunction === option
                });

                return (
                    <div key={key} className={classes} onClick={()=>{onClickOption(option)}}>
                        {/*<div className={Classes("ico", gd.const.aggregate.icon[option])}/>*/}
                        <div className="label">{gd.const.aggregate.name[option]}</div>
                    </div>
                );
            })}

            {!!props.menuParams.aggregateFunction &&
            <div className="option" onClick={()=>{onClickOption(null)}}>
                <div className="label">None</div>
            </div>}
        </div>
    );
}